import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from "./store"
import { BrowserRouter as Router } from "react-router-dom";
import DynamicThemeProvider from './pages/Utils/DynamicThemeProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Provider store={store}>
      <DynamicThemeProvider>
        <App />
      </DynamicThemeProvider>
    </Provider>
  </Router>
);
